export const gbMSEMenus = {
    type: 'public',
    logoItems: [
        {
            id: '3f7573d4-7cce-42d0-8263-f0d9079e2b11',
            href: '/',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/bltb82e5f4f2a225d83/raisin-logo.svg',
            alt: 'Raisin',
        },
        {
            id: '0d3f65cb-ba91-41f0-9e30-efd906a801f0',
            href: '/register?regflow=mse_savings_hub',
            url: 'https://eu-images.contentstack.com/v3/assets/blt4a5ee0113ab335fb/blt4586e82bb5559ec4/673df80ac8592fa98b678c34/MSE-logo-no-strap_(1).svg',
            alt: 'mse_savings_hub',
        },
    ],
    navItems: [],
    actionItems: [
        {
            id: '659be2f1-cdfa-4666-bcbb-edf874ad83ce',
            title: 'Log in',
            href: '/login/',
            type: 'login',
        },
    ],
};
//# sourceMappingURL=gbMSEMenus.js.map